'use strict';

import React from 'react';
import flux from 'utils/flux';
import Immutable from 'immutable';
import Thumb from 'components/thumb';
import prettyBytes from 'pretty-bytes';

var BasketListingItem = React.createClass({

    displayName: 'BasketListingItem',

    mixins: [],

    propTypes: {
        item: React.PropTypes.object
    },

    shouldComponentUpdate( nextProps ) {
        return ( Immutable.is( nextProps.item, this.props.item ) === false );
    },

    toggleCheck( size, e ) {
        e.preventDefault();
        flux.getActions('basket').toggleDownload({ itemId: this.props.item.get('id'), fileKey: size });
    },

    removeItem(e) {
        e.preventDefault();
        flux.getStore('basket').deleteBasketItem( this.props.item.get('id') );
    },

    render() {
        var item = this.props.item.toJS();
        const { meta } = item;
        const { files } = item;
        const master = files.find( file => 'master' === file.key ) || ( files.length && files[0] );
        const MICode = meta.find( meta => 'MICode' === meta.key );
        const duration = master && master.meta && master.meta.find && master.meta.length > 0 && master.meta.find( meta => 'Duration' === meta.name );

        return (
            <div className="basket__item">
                <div className="item__image">
                    <Thumb className="item__preview" media={this.props.item} onClickOpenModal={true} isBasketItem={true} />
                </div>
                <div className="item__description">
                    <div className="description__title">
                        {item.title.length ? item.title : '&nbsp;'}
                        <a href="#" onClick={this.removeItem} className="item__remove">
                            <span className="close-small" />
                            {flux.t('remove_baskets')}
                        </a>
                    </div>

                    <div className="description__meta">
                        {MICode && MICode.value.length > 0 && <span className="meta__id">{MICode.value}</span>}
                        {duration && duration.value.length > 0 && <span className="meta__duration">{duration.value}</span>}
                    </div>

                    <div className="description__download">
                        <form>
                            <table>
                                <thead>
                                    <th className="download__head--checkbox">&nbsp;</th>
                                    <th>{flux.t('download_file_format')}</th>
                                    <th>{flux.t('download_file_mimetype')}</th>
                                    <th>{flux.t('download_file_size')}</th>
                                </thead>
                                <tbody>
                                    {item.files.map( file => {
                                        var dimensions = file.meta && file.meta.length > 0 && file.meta.find( meta => !meta.hidden && 'Dimensions' === meta.name );
                                        return (
                                            <tr key={'i-' + item.id + '-' + file.key}>
                                                <td className="file__key download__body--checkbox">
                                                    <div className="field__checkbox download__checkbox">
                                                        <input id="check__all" checked={file._download} type="checkbox" readOnly />
                                                        <label onClick={this.toggleCheck.bind(null, file.name)} htmlFor="check__all">{file.name}</label>
                                                    </div>
                                                </td>
                                                <td className="file__dimensions">{dimensions && dimensions.value}</td>
                                                <td className="file__mimetype">{file.mimeType}</td>
                                                <td className="file__size">{prettyBytes(file.size)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = BasketListingItem;



// WEBPACK FOOTER //
// ./app/pages/basket/basketListingItem.jsx